import { render, staticRenderFns } from "./external-links.vue?vue&type=template&id=7af74346&scoped=true"
import script from "./external-links.vue?vue&type=script&lang=js"
export * from "./external-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af74346",
  null
  
)

export default component.exports